import React from "react";
import { Box } from "@mui/material";
import OstFileDropZone from "./OstFileDropZone";
import { useOst } from "./OstContext";
import { useDrawerActions } from "../../../context/DrawerContext";
import { useDatasources } from "../../../context/DatasourceContext";

const OSTUpload: React.FC = () => {
  const { ostState, uploadOstFile } = useOst();
  const { closeDrawer } = useDrawerActions();
  const { addDatasource } = useDatasources();

  const handleFileSelected = async (file: File) => {
    const uploaded = await uploadOstFile(file);
    if (!uploaded) return;
    addDatasource("takeOff", "ost");
    closeDrawer();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box
        component="img"
        src={"assets/partner_logos/OST.svg"}
        alt={`On Screen Takeoff Logo`}
        sx={{ height: "29px", display: "block", mb: "16px" }}
      />
      <OstFileDropZone onFileSelected={(file) => void handleFileSelected(file)} loading={ostState === "loading"} />
    </Box>
  );
};

export default OSTUpload;
